// Zentrale Statusregel für ALLE Ticketlisten (W0-6, #38, Beschluss 56 auf #43):
// Abgeschlossene Tickets sind ausgeblendet, solange der „Auch Abgeschlossene"-
// Schalter aus ist — unabhängig von Lesezuständen. Die frühere Ausnahme
// „außer bei neuer Aktivität" führte dazu, dass nie angesehene Alt-Tickets
// dauerhaft in den Listen klebten. Neue Aktivität auf einem abgeschlossenen
// Ticket wird über die Reopen-/Vorgangs-Mechanik sichtbar (A3/#37), nicht
// über eine Ausnahme in der Statusfilterung.
export const isHiddenByStatus = (ticket, { showCompleted = false } = {}) =>
  !showCompleted && !!ticket && ticket.status === 'abgeschlossen';
